import React, { Component } from 'react';
import AdmissionApi from '../../Services/AdmissionApi';

import './style.css';


class ForgotPasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_name: '',
            password: '',
            confirm_password: '',
            id: 'signin-link',
            newPassword: '',
            oldPassword: '',
            user_id: '',
            isNewPassword: false,
            random: 0,
            errors: {},
            email_masg: {},
            check: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.recoverPassowrd = this.recoverPassowrd.bind(this);
        this.goToLogin = this.goToLogin.bind(this);

        this.admissionsService = new AdmissionApi();
    }

    componentDidMount() {
        let { reset, userName } = this.props
        if (reset) {
            this.setState({ isNewPassword: true, user_name: userName });
        } else {
            this.setState({ user_name: userName });
        }
    }


    handleChange(evt) {
        if (this.state.check) {
            if (!this.state.isNewPassword) {
                this.handleValidation();
            } else {
                this.handlePasswordValidation();
            }

        }
        this.setState({ [evt.target.name]: evt.target.value });
    }


    updateState = (newResponse) => {
        if (newResponse.data.success) {

        }
    }

    checkEmailExistance = (newResponse) => {
        if (newResponse.data.success) {

            let obj = {
                action: 'reset_password',
                address: { to: this.state.user_name, name: newResponse.data.attributes.first_name + " " + newResponse.data.attributes.last_name },
                mail_data: { reset_link: window.location.href.split('#')[0] + '/resetpassword?email=' + this.state.user_name, user_name: this.state.user_name }

            };
            this.admissionsService.sendMail(this.updateState, obj, 'settings/v1/mail/send');
            let message = {};
            message["user_name"] = "We have sent an email to your email id, please check.";
            this.setState({ email_masg: message, check: false });
        } else {
            let errors = {};
            errors['responseError'] = "Please enter valid email address"
            this.setState({ errors: errors });
        }
    }

    updateView = (newResponse) => {
        if (newResponse.data.success) {
            this.props.changeToLogin('signin-link');
        } else {
            let errors = {};
            errors['responseError'] = 'Invalid Reset Password Link';
            this.setState({ errors: errors });
            // if (newResponse.data.message) {
            //     errors['responseError'] = newResponse.data.message;
            // } else {
            //     errors['responseError'] = newResponse.data.message;
            // }
        }
    }

    errorsHandling(data) {
        let errors = {};
        Object.keys(data).forEach(function (key, i) {
            errors[key] = data[key][0];
        });

        this.setState({ errors: errors });
    }


    recoverPassowrd(e) {
        e.preventDefault()
        this.setState({ check: true });
        if (this.handleValidation()) {
            let obj = { email: this.state.user_name };
            this.admissionsService.createNew(this.checkEmailExistance, obj, 'v1/users/check-email');
        }
    }

    goToLogin(e) {
        e.preventDefault()
        const { user_name, password } = this.state
        this.setState({ check: true });
        if (this.handlePasswordValidation()) {
            let obj = { email: user_name, newPassword: password };

            this.admissionsService.createNew(this.updateView, obj, 'v1/users/reset-password');
        }
    }

    handleValidation() {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;

        //Email
        if (!fields["user_name"]) {
            formIsValid = false;
            errors["user_name"] = "Cannot be empty";
        }

        if (typeof fields["user_name"] !== "undefined") {
            let lastAtPos = fields["user_name"].lastIndexOf('@');
            let lastDotPos = fields["user_name"].lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["user_name"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["user_name"].length - lastDotPos) > 2)) {
                formIsValid = false;
                errors["user_name"] = "Email is not valid";
            }
        }

        errors['responseError'] = '';

        this.setState({ errors: errors });
        return formIsValid;
    }

    handlePasswordValidation() {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;


        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "Cannot be empty";
        }

        if (!fields["confirm_password"]) {
            formIsValid = false;
            errors["confirm_password"] = "Cannot be empty";
        }

        if (fields["confirm_password"] != fields["password"]) {
            formIsValid = false;
            errors["confirm_password"] = "Please check, Password and Confirm Password did not matched";
        }


        this.setState({ errors: errors });
        return formIsValid;
    }


    showSelectedId = (event) => {
        this.props.changeForm(event);
    }

    render() {

        return (
            <div>
                {!this.state.isNewPassword ? <div className="g-bg-white rounded">
                    <div className={(this.state.errors["user_name"] || this.state.email_masg["user_name"] || this.state.errors["responseError"] || this.state.errors["mail_sent"]) ? null : 'g-mb-10'}>
                        <h1>Forgot Password?</h1>
                        <div className="input-group admn-input-group">
                            <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                                <i className="fa fa-envelope"></i>
                            </span>
                            <input className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12" type="text" placeholder="E-mail address" name="user_name" onChange={this.handleChange} />
                        </div>
                        <span style={{ color: "red" }}>{this.state.errors["user_name"]}</span>
                        <span style={{ color: "green" }}>{this.state.email_masg["user_name"]}</span>
                        <span style={{ color: "red" }}>{this.state.errors["responseError"]} {this.state.errors["mail_sent"]}</span>
                    </div>

                    <div className="d-flex">
                        <button type="submit" className="admn-btn btn w-100 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-font-size-default rounded g-px-25 g-py-7 ml-auto" onClick={this.recoverPassowrd}>Recover Password</button>
                    </div>
                    <div className='text-center'>Remember your password? <button type='button' className="btn btn-link p-0 auth-link" id="signin-link" onClick={(event) => this.showSelectedId(event)}>Login</button></div>
                </div> :
                    <div className="g-bg-white rounded">
                        <h1>Reset Password</h1>
                        <div className={(this.state.email_masg["user_name"] || this.state.errors["password"]) ? null : 'g-mb-10'}>
                            <div className="input-group admn-input-group">
                                <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                                    <i className="fa fa-envelope"></i>
                                </span>
                                <input className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12" type="password" placeholder="Password" value={this.state.password} name="password" onChange={this.handleChange} />
                            </div>
                            <span style={{ color: "green" }}>{this.state.email_masg["user_name"]}</span>
                            <span style={{ color: "red" }}>{this.state.errors["password"]}</span>
                        </div>

                        <div className={this.state.errors["confirm_password"] || this.state.errors["responseError"] ? null : 'g-mb-10'}>
                            <div className="input-group admn-input-group">
                                <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                                    <i className="fa fa-envelope"></i>
                                </span>
                                <input className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12" type="password" placeholder="Confirm password" name="confirm_password" onChange={this.handleChange} />
                            </div>
                            <span style={{ color: "red" }}>{this.state.errors["confirm_password"]}</span>
                            <span style={{ color: "red" }}>{this.state.errors["responseError"]}</span>
                        </div>

                        <div className="d-flex">
                            <button type="submit" className="admn-btn w-100 btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-font-size-default rounded g-px-25 g-py-7 ml-auto" onClick={this.goToLogin}>Submit new password</button>
                        </div>
                        <div className='text-center'>Remember your password? <a className="p-0 auth-link" id="signin-link" href='/signIn'>Login</a></div>
                    </div>}
            </div>
        );
    }
}

export default ForgotPasswordForm;



/** WEBPACK FOOTER **
 ** ./src/components/SignIn/ForgotPasswordForm.js
 **/